import { useQuery } from '@tanstack/react-query';
import { getRecentMceEvents } from '@app/api/routes/mce/recentMceEvents';
import type { GetRecentMceEventsResponse } from '@app/api/routes/mce/recentMceEvents.types';

export const RECENT_MCE_EVENTS_QUERY_KEY = ['mce-events', 'recent'] as const;

/**
 * Récupère les 3 derniers événements MCE pour l'aperçu "Activité récente"
 * de la home Comète On Time.
 *
 * Endpoint léger sans filtre. Pour la timeline complète et filtrable,
 * utiliser `useGetMceEvents`.
 */
export const useGetRecentMceEvents = () =>
  useQuery<GetRecentMceEventsResponse>({
    queryKey: RECENT_MCE_EVENTS_QUERY_KEY,
    queryFn: getRecentMceEvents,
    staleTime: 30_000
  });
